export const PRE_AUTH_PAYMENT_CONFIRMATION_SAMPLE = {
  organizationName: 'Stratos Jets',
  invoice: {
    invoice_number: 'TR-1782460750614-961',
    quote_number: 'TR-1782460750614-961',
    subtotal: 1664.60,
    tax_amount: 166.46,
    card_fee: 73.25,
    total_amount: 1831.06,
    items: [
      { item: 'Limousine service', amount: 446.60 },
      { item: 'In-house standard catering', amount: 1218.00 },
    ],
    client: {
      first_name: 'Sarah',
      last_name: 'Mitchell',
      payment_info: {
        passport: {
          card: {
            brand: 'Visa',
            last4: '3456',
          },
        },
      },
    },
  },
};
